/**
 * Bump whenever the lean pipeline changes what a session's lean series
 * contains. The contract test pins a fingerprint of the paired real
 * fixtures per version.
 *
 * A lean change also requires a LAP_PROCESSING_VERSION bump: the mobile lap
 * cache (PitBrain.Mobile/api/ProcessedLapsCache.ts) keys its entries on that
 * constant, so laps cached before the change keep serving the old lean until
 * it moves. Precedent: LAP_PROCESSING_VERSION 3, whose history entry is the
 * previous lean-estimator rebuild.
 */
export const LEAN_PROCESSING_VERSION = 4
